import {
  FieldTypes,
  AIRTABLE,
  REST_API,
  DATABASE,
  EMAIL_TEMPLATE,
  SMS_TEMPLATE,
  FIREBASE_REALTIME_DATABASE,
  FIREBASE_CLOUD_FIRESTORE,
  FIREBASE_FUNCTION,
  INTEGROMAT,
  GOOGLE_SHEET,
  CHAT_GPT,
  TOOLTIP_TEMPLATE,
  TYPESENSE_SEARCH_TEMPLATE,
  SOCKET_IO_TEMPLATE,
  MYSQL,
  SUPABASE,
  APPWRITE,
  XANO,
  XATA,
  DIRECTUS,
  SALESFORCE,
  POSTGRESQL,
  SQLITE,
  AURORA,
  MARIADB,
  ORACLEDB,
  MS_SQL_SERVER,
  ZAPIER,
} from 'drapcode-constant';

export const drapcodeIcon = (type) => {
  switch (type) {
    case 'alarm':
      return 'webconnect-alarm';
    case 'fullscreen':
      return 'webconnect-arrows-fullscreen';
    case 'description':
      return 'webconnect-info-circle';
    case 'warning':
      return 'webconnect-exclamation-triangle-fill';
    case 'collection':
    case 'collectionSnapshot':
    case 'dataSourceDatabase':
    case 'Data Sources':
    case DATABASE:
    case 'dbExport':
    case 'Browser Storage':
    case 'fieldObjectMapping':
      return 'webconnect-database';
    case 'events':
    case 'indexing':
      return 'webconnect-diagram-3-fill';
    case 'conditions':
      return 'webconnect-signpost-2-fill';
    case 'data-source':
      return 'webconnect-hdd-stack-fill';
    case 'appSettings':
      return 'webconnect-home';
    case 'plugins':
      return 'webconnect-tools';
    case 'template':
    case 'PAGES':
    case 'pages':
    case 'js-update-page':
      return 'webconnect-file-alt';
    case 'sendDynamicMessage':
    case SMS_TEMPLATE:
      return 'webconnect-chat-left-text';
    case TOOLTIP_TEMPLATE:
    case 'info':
    case 'displayToolTip':
      return 'webconnect-info-circle-fill';
    case 'create':
    case 'add':
      return 'webconnect-plus';
    case 'update':
    case 'submit':
    case 'save':
    case 'updateCollectionWithReferenceItems':
    case 'updateCollection':
    case 'bulkUpdateCollection':
    case 'updateCollectionAssets':
    case 'updateItemInMetaDataTable':
      return 'webconnect-save-regular';
    case 'edit':
      return 'webconnect-pencil';
    case 'setup':
    case 'appConfig':
      return 'webconnect-cog';
    case 'configure':
    case 'advanced':
      return 'webconnect-cogs';
    case 'install':
      return 'webconnect-download';
    case 'appConstant':
    case 'fields':
      return 'webconnect-form';
    case 'pageSettings':
    case 'pageSetting':
    case 'constructors':
      return 'webconnect-bricks';
    case 'pageSnapshots':
    case 'pageSnapshot':
    case 'derivedFields':
      return 'webconnect-box-arrow-in-right';
    case 'customCss':
    case 'customCSS':
      return 'webconnect-paint-brush';
    case 'constants':
    case 'Delete Permissions':
      return 'webconnect-vector-pen';
    case 'snippetSnapshots':
    case 'snippetShapshot':
    case 'filters':
      return 'webconnect-funnel';
    case 'robotTxt':
    case 'robots':
    case 'constraints':
      return 'webconnect-gear';
    case 'list':
      return 'webconnect-card-list';
    case 'form':
      return 'webconnect-edit';
    case 'clear':
    case 'eraser':
    case 'reset':
    case 'clearBrowserSessionData':
    case 'clearBrowserStorageData':
      return 'webconnect-eraser';
    case 'validations':
      return 'webconnect-shield';
    case 'cancel':
      return 'webconnect-times';
    case 'next':
    case 'skip':
    case 'goto':
      return 'webconnect-skip-forward-fill';
    case 'dataSourceGoogleSheet':
    case GOOGLE_SHEET:
      return 'webconnect-file-spreadsheet';
    case 'dataSourceRestAPI':
    case REST_API:
    case 'ExternalAPIs':
    case 'External APIs':
      return 'webconnect-rocket';
    case 'devKey':
      return 'webconnect-key';
    case 'dataSourceAirtable':
    case AIRTABLE:
    case 'data-table':
      return 'webconnect-table';
    case 'dataSourceFirebaseRealtimeDatabase':
    case FIREBASE_REALTIME_DATABASE:
      return 'webconnect-collection-fill';
    case 'dataSourceFirebaseFunction':
    case FIREBASE_FUNCTION:
      return 'webconnect-code-square';
    case 'dataSourceFirebaseCloudFirestore':
    case FIREBASE_CLOUD_FIRESTORE:
      return 'webconnect-cloudy-fill';
    case 'response':
    case 'terminal':
      return 'webconnect-terminal';
    case 'send':
    case 'send-request':
      return 'webconnect-cursor-fill';
    case 'back':
      return 'webconnect-chevron-double-left';
    case 'externalapi':
    case 'webhook':
      return 'webconnect-plug-fill';
    case 'integromat':
    case INTEGROMAT:
      return 'webconnect-power';
    case 'zapier':
    case 'ZAPIER':
      return 'webconnect-asterisk';
    case 'signUpUser':
    case 'signupAndLoginUser':
    case 'addNewUserToTenant':
    case 'createAndAddNewUserToTenant':
    case 'saveUserWithCollectionReference':
    case 'updateCurrentTenantData':
    case 'updateCurrentUserSettingData':
      return 'webconnect-person-plus-fill';
    case 'signupAndLoginAnonymousUser':
      return 'webconnect-person-lines-fill';
    case 'loginUser':
    case 'Login / Signup':
    case 'loginUserWithToken':
    case 'verifyEmailOTP':
    case 'verifySmsOTP':
      return 'webconnect-login';
    case 'socialLoginSignup':
      return 'webconnect-person-circle';
    case 'logoutUser':
    case 'forceLogoutUser':
      return 'webconnect-logout';
    case 'system_show_component':
    case 'showModal':
    case 'showBulkUpdateModal':
    case 'Show / Hide Sections':
    case 'conditionalOpenModal':
      return 'webconnect-eye-fill';
    case 'displaySubPage':
    case 'conditionalOpenSubpage':
      return 'webconnect-file-earmark-richtext';
    case 'goToPage':
    case 'Navigation':
    case 'navigation':
    case 'dynamicPageRedirect':
    case 'customPageRedirect':
      return 'webconnect-box-arrow-up-right';
    case 'sendEmail':
    case 'sendDynamicEmail':
    case 'sendResetPasswordEmail':
    case EMAIL_TEMPLATE:
    case 'generateEmailOTP':
    case 'generateUserConsentEmailOTP':
      return 'webconnect-envelope-fill';
    case 'resetNewPassword':
      return 'webconnect-wrench';
    case 'chnageOldPassword':
      return 'webconnect-front';
    case 'showAlertMessage':
    case 'Notification':
      return 'webconnect-megaphone-fill';
    case 'saveUserWithCollectionReference':
    case 'saveCollectionWithReferenceItems':
    case 'saveCollection':
    case 'saveCollectionAssets':
    case 'verifyUserConsentEmailOTP':
    case 'verifyUserConsentSmsOTP':
    case 'saveItemInMetaDataTable':
      return 'webconnect-save-solid';
    case 'updateCollectionOnPageLoad':
    case 'updateCollectionFieldDerivedField':
    case 'updateCollectionFieldBrowserSession':
      return 'webconnect-save-fill';
    case 'addToCollectionItem':
      return 'webconnect-layers-fill';
    case 'removeFromCollectionItem':
      return 'webconnect-layers-half';
    case 'deleteCollectionItem':
    case 'removeCollectionFieldData':
    case 'delete':
    case 'deleteTypesenseCollection':
    case 'deleteItemInMetaDataTable':
      return 'webconnect-trash-solid';
    case 'sendDataToExternalApi':
      return 'webconnect-cloud-fog2-fill';
    case 'sendDataToExternalApiAndFileDownload':
      return 'webconnect-cloud-arrow-down';
    case 'fileUpload':
      return 'webconnect-upload';
    case 'system_hide_component':
      return 'webconnect-eye-slash-fill';
    case 'closeModal':
    case 'error':
      return 'webconnect-x-circle';
    case 'reloadPage':
    case 'refreshCurrentLoggedInUser':
    case 'refreshCurrentTenant':
    case 'refreshCurrentUserSettings':
    case 'reindexDataForTypesenseCollection':
    case 'mapAllDataInMetaDataTable':
      return 'webconnect-refresh';
    case 'refreshSection':
    case 'loadingIcon':
      return 'webconnect-arrow-repeat';
    case 'Collection':
      return 'webconnect-stack';
    case 'Snippet / Modal Popup':
    case 'cloneCollectionItem':
      return 'webconnect-clone';
    case 'ExternalApis':
    case 'localization':
    case 'switchLocalizationLang':
      return 'webconnect-globe';
    case 'customCSSClasses':
      return 'webconnect-palette';
    case 'workflow':
      return 'webconnect-bar-chart-steps';
    case 'team':
    case 'teamManagement':
    case 'updateCurrentLoggedInUserData':
    case 'Multi Tenant':
      return 'webconnect-people-fill';
    case 'important':
      return 'webconnect-pin-angle-fill';
    case 'environment':
      return 'webconnect-inboxes';
    case 'customCSSURL':
    case 'customCssUrl':
    case 'customJSCDN':
    case 'customJsCDN':
    case 'link':
    case 'sendSocketMessage':
    case SOCKET_IO_TEMPLATE:
      return 'webconnect-lightning-charge-fill';
    case 'customCSSFileUpload':
    case 'customCssFileUpload':
      return 'webconnect-file-earmark-arrow-up';
    case 'customJS':
    case 'customJs':
      return 'webconnect-puzzle';
    case 'snapshot':
    case 'snapshots':
    case 'initiateQRCodeReader':
      return 'webconnect-camera-fill';
    case 'customCssJs':
      return 'webconnect-sliders';
    case 'pwa':
    case 'pwaConfig':
    case 'mobile':
    case 'phone':
      return 'webconnect-phone';
    case 'search':
    case 'typesenseMapping':
    case 'Typesense Search':
    case TYPESENSE_SEARCH_TEMPLATE:
      return 'webconnect-search';
    case 'text':
    case 'Text Anonymization':
      return 'webconnect-capital';
    case 'header':
      return 'webconnect-heading';
    case 'paragraph':
      return 'webconnect-paragraph';
    case 'bootstrap_button':
      return 'webconnect-bootstrap-fill';
    case 'form':
    case 'collection-form':
    case 'login-form':
    case 'search-form':
      return 'webconnect-newspaper';
    case 'input':
      return 'webconnect-input';
    case 'select':
    case 'navbar':
    case 'dependentDropDownPopulateOnChange':
      return 'webconnect-menu-button-wide-fill';
    case 'data-list':
      return 'webconnect-list-square-rounded-interface';
    case 'data-group':
      return 'webconnect-list-2';
    case 'Import/Export Collection Data':
      return 'webconnect-file-earmark-zip';
    case 'importCollectionItem':
      return 'webconnect-file-arrow-up';
    case 'exportCollectionItem':
      return 'webconnect-file-arrow-down';
    case 'codeExport':
      return 'webconnect-cloud-download';
    case 'customFonts':
      return 'webconnect-font';
    case 'drapcode-icons':
    case 'globalTheme':
    case 'overwriteDefaultUI':
      return 'webconnect-star';
    case 'iframe':
      return 'webconnect-frame';
    case 'link-box':
      return 'webconnect-link';
    case 'box':
      return 'webconnect-square';
    case 'jumbotron':
      return 'webconnect-credit-card-2-front-fill';
    case 'stripe-connect-buy':
      return 'webconnect-cart-check';
    case 'timeout':
      return 'webconnect-hourglass-split';
    case 'logs':
      return 'webconnect-file-text';
    case 'resetFormFields':
      return 'webconnect-eraser-fill';
    case 'Form':
    case 'OCR to Text':
      return 'webconnect-file-earmark-text-fill';
    case 'submitSelectedForm':
      return 'webconnect-save2-fill';
    case 'showConfirmationMessage':
      return 'webconnect-shield-fill-exclamation';
    case 'customTheme':
      return 'webconnect-file-zip';
    case 'triggerZap':
      return 'webconnect-cloud-fog2';
    case 'encryption':
    case 'sendDataToExternalApiAndAuthorize':
    case 'Permission':
    case 'permissionLevelSecurity':
    case 'rowLevelSecurity':
    case 'changePermissionInTenant':
    case 'changePermissionInUser':
    case 'changePermissionInUserSettings':
      return 'webconnect-shield-lock ';
    case 'lock':
      return 'webconnect-lock-fill';
    case 'decryption':
      return 'webconnect-shield-slash';
    case 'continue':
      return 'webconnect-arrow-right';
    case 'previous':
      return 'webconnect-arrow-left';
    case 'sync':
      return 'webconnect-arrow-left-right';
    case 'step-complete':
      return 'webconnect-check2-circle';
    case 'step-pending':
      return 'webconnect-plus-circle-dotted';
    case 'version':
      return 'webconnect-patch-plus';
    case 'toggle':
      return 'webconnect-toggles';
    case 'notification':
    case 'notificationSetting':
      return 'webconnect-bell';
    case 'meta-fields':
      return 'webconnect-receipt';
    case 'removeTenantFromMultipleRoles':
    case 'removeUserFromTenant':
      return 'webconnect-person-dash-fill';
    case 'addUserToTenant':
      return 'webconnect-person-check-fill';
    case 'switchUserTenant':
      return 'webconnect-address-book';
    case 'switchSubTenant':
      return 'webconnect-address-book-outline';
    case 'setBrowserSessionData':
      return 'webconnect-journal-plus';
    case 'setBrowserStorageData':
      return 'webconnect-inboxes-fill';
    case 'Others':
    case 'Miscellaneous':
      return 'webconnect-command';
    case 'dateFormat':
    case 'googleCalendarMapping':
      return 'webconnect-calendar2-month';
    case 'customComponent':
    case 'displayCustomComponent':
      return 'webconnect-easel';
    case 'htmlContent':
    case 'vibeCoding':
    case 'vibe-coding':
      return 'webconnect-code-slash';
    case 'saveCollectionDraft':
      return 'webconnect-archive-fill';
    case 'updateCollectionDraft':
      return 'webconnect-archive';
    case 'switchEntity':
      return 'webconnect-box-seam';
    case 'customDataMapping':
      return 'webconnect-bezier2';
    case 'dashboard':
      return 'webconnect-x-diamond-fill';
    case 'PROFILER':
    case 'profiler':
      return 'webconnect-speedometer2';
    case 'system-activity':
      return 'webconnect-cpu';
    case 'publish-activity':
      return 'webconnect-paper-plane';
    case 'pause':
      return 'webconnect-pause';
    case 'resume':
      return 'webconnect-play';
    case 'on-boarding':
      return 'webconnect-house-door-fill';
    case 'AI/ChatGPT':
    case 'AI / ChatGPT':
    case 'startNewGptConversation':
    case 'continueGptConversation':
    case 'queryFromTypesense':
    case 'thinking':
      return 'webconnect-lightbulb-fill';
    case 'model':
      return 'webconnect-cpu';

    case 'resources':
      return 'webconnect-cloud-arrow-up';
    case 'view':
      return 'webconnect-eye';
    case 'remove':
      return 'webconnect-trash-regular';
    case 'verifyTwoFactorAuthentication':
    case 'verificationprocess':
      return 'webconnect-shield-lock-fill';
    case 'pdfToText':
    case 'anyFileToText':
      return 'webconnect-file-text';
    case 'Loan Management':
    case 'createLoanRepayments':
      return 'webconnect-wallet2';
    case 'amazonTextract':
      return 'webconnect-file-text';
    case 'sitemapXml':
      return 'webconnect-diagram-3';
    case 'deployment':
      return 'webconnect-nut-fill';
    case 'history':
      return 'webconnect-journal-text';
    case 'typographyColours':
      return 'webconnect-palette2';
    case 'nlpAnonymization':
      return 'webconnect-text-center';
    case 'customTermsAnonymization':
      return 'webconnect-file-earmark-font';
    case 'Docusign':
      return 'webconnect-pen-fill';
    case 'initiateDocusign':
    case 'fetchDocusignSigningStatus':
      return 'webconnect-pen';
    case 'sendForEsign':
      return 'webconnect-paper-plane';
    case 'aiModelConfig':
    case 'aiModelConfiguration':
      return 'webconnect-outlet';
    case 'github':
      return 'webconnect-github';
    case 'runJavaScriptCode':
      return 'webconnect-file-code-fill';
    case 'loaderScreen':
      return 'webconnect-refresh';
    case 'importProject':
      return 'webconnect-box-arrow-down';
    case 'loginWithFacebook':
    case 'signUpWithFacebook':
      return 'webconnect-facebook';
    case 'loginWithTwitter':
    case 'signUpWithTwitter':
      return 'webconnect-twitter';
    case 'OTP Authentication':
    case 'phiAudit':
      return 'webconnect-shield-check';
    case 'collectionMapping':
    case 'Meta Data Table':
      return 'webconnect-2colum-6-12-6-12';
    case 'image':
      return 'webconnect-card-image';
    case 'section':
      return 'webconnect-section';
    case 'Custom Function':
    case 'customFunction':
    case 'triggerCustomFunction':
      return 'webconnect-puzzle-fill';
    case 'Import / Export Collection Data':
      return 'webconnect-file-zip';
    case 'Google':
      return 'webconnect-google';
    case 'generatePdfFromSnippet':
    case 'generatePdfFromSection':
    case 'generatePDFWithBrowserAPI':
    case 'generatePdfFromAgreementTemplate':
      return 'webconnect-layout-text-sidebar-reverse';
    case 'openFloatingModal':
      return 'webconnect-files-alt';
    case 'fetchDocusignContractDetails':
      return 'webconnect-file-richtext';
    case 'generateSmsOTP':
    case 'generateUserConsentSmsOTP':
      return 'webconnect-chat-left-dots-fill';
    case 'generateOnlySMSOTP':
    case 'generateOnlyEmailOTP':
    case 'generateOnlyUserConsentEmailOTP':
    case 'generateOnlyUserConsentSmsOTP':
      return 'webconnect-ellipsis-h-solid';
    case 'cibilConsumerReport':
    case 'CIBIL':
      return 'webconnect-money-check';
    case 'Misc':
      return 'webconnect-stars';
    case 'Signature Pad':
    case 'saveSignature':
    case 'clearSignature':
      return 'webconnect-pen-fill';
    default:
      return 'webconnect-edit';
  }
};

export const iconForField = (type) => {
  if ([FieldTypes.date.id, FieldTypes.unix_timestamp.id].includes(type))
    return 'webconnect-calendar2-month';
  if (type === FieldTypes.password.id) return 'webconnect-key';
  if (type === FieldTypes.color.id) return 'webconnect-palette';
  if (type === FieldTypes.file.id) return 'webconnect-paperclip';
  if (type === FieldTypes.belongsTo.id) return 'webconnect-share';
  if (type === FieldTypes.reference.id) return 'webconnect-inboxes';
  if (type === FieldTypes.image.id) return 'webconnect-image';
  if (type === FieldTypes.multi_image.id) return 'webconnect-images-regular';
  if (type === FieldTypes.video_link.id) return 'webconnect-camera-video';
  if (type === FieldTypes.url.id || type === 'link') return 'webconnect-link';
  if (type === FieldTypes.tel.id) return 'webconnect-telephone';
  if (type === FieldTypes.email.id) return 'webconnect-at';
  if (type === FieldTypes.dynamic_option.id || type === 'collection')
    return 'webconnect-collection';
  if (type === FieldTypes.static_option.id || type === 'dropdownIcon') return 'webconnect-justify';
  if (type === FieldTypes.large_text.id) return 'webconnect-newspaper';
  if (type === FieldTypes.number.id) return 'webconnect-sort-numeric-up-alt';
  if (type === FieldTypes.boolean.id || type === 'checkbox') return 'webconnect-check-square';
  if (type === 'text') return 'webconnect-pencil';
  if (type === FieldTypes.boolean.id + '-toggle' || type === 'toggle') return 'webconnect-toggles';
  if (type === 'select' || type === 'dropdown') return 'webconnect-menu-button-wide-fill';
  if (
    type === 'text-placeholder' ||
    type === FieldTypes.custom_uuid.id ||
    type === FieldTypes.json.id
  )
    return 'webconnect-braces';
  if (type === 'sidebar') return 'webconnect-layout-text-sidebar';
  if (type === 'reverse-sidebar') return 'webconnect-layout-text-sidebar-reverse';
  if (type === 'diagram-2') return 'webconnect-diagram-2';
  if (type === 'capslock') return 'webconnect-capslock';
  if (type === 'sort-up') return 'webconnect-sort-up';
  if (type === 'files') return 'webconnect-files';
  if (type === 'devKey') return 'webconnect-key';
  if (type === FieldTypes.time_slot.id) return 'webconnect-calendar2-plus';
  if (type === FieldTypes.time_picker.id) return 'webconnect-clock';
  if (type === 'lock') return 'webconnect-lock-fill';
  if (type === 'globe') return 'webconnect-globe';
  return 'webconnect-file-text';
};

export const drapcodeImgIcon = (name, type = 'dataSource', ext = 'png') => {
  let imgName = '';
  switch (name) {
    case 'supabase':
    case 'Supabase':
    case SUPABASE:
      imgName = 'supabase';
      break;
    case 'appwrite':
    case 'Appwrite':
    case APPWRITE:
      imgName = 'appwrite';
      break;
    case 'xano':
    case 'Xano':
    case XANO:
      imgName = 'xano';
      break;
    case 'xata':
    case 'Xata':
    case XATA:
      imgName = 'xata';
      break;
    case 'directus':
    case 'Directus':
    case DIRECTUS:
      imgName = 'directus';
      break;
    case 'airtable':
    case 'Airtable':
    case AIRTABLE:
      imgName = 'airtable';
      break;
    case 'salesforce':
    case 'Salesforce':
    case SALESFORCE:
      imgName = 'salesforce';
      break;
    case 'postgresql':
    case POSTGRESQL:
      imgName = 'postgresql';
      break;
    case 'mysql':
    case 'mySQL':
    case 'mySql':
    case MYSQL:
      imgName = 'mysql';
      break;
    case 'sqlite':
    case SQLITE:
      imgName = 'sqlite';
      break;
    case 'ms-sql-server':
    case MS_SQL_SERVER:
      imgName = 'ms-sql-server';
      break;
    case 'oracledb':
    case ORACLEDB:
      imgName = 'oracledb';
      break;
    case 'mariadb':
    case MARIADB:
      imgName = 'mariadb';
      break;
    case 'aurora':
    case AURORA:
      imgName = 'aurora';
      break;
    case 'zapier':
    case ZAPIER:
      imgName = 'zapier';
      break;
    default:
      if (ext) {
        imgName = ext === 'svg' ? 'database' : 'drapcode';
      } else {
        imgName = 'drapcode';
      }
      break;
  }
  try {
    return require(`../${type || 'dataSource'}/img/${imgName}.${ext || 'png'}`);
  } catch (error) {
    //Fallback to drapcode image icon
    return require(`../dataSource/img/drapcode.png`);
  }
};
